import PropTypes from "prop-types";
import React, { Component } from "react";

/**
 * Registers the provided translate function in the context so
 * children can use <TextMessage /> components expecting it
 */
export default class SimpleTranslateProvider extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    translate: PropTypes.func.isRequired,
  };

  static childContextTypes = {
    t: PropTypes.func.isRequired,
  };

  getChildContext() {
    return {
      t: this.props.translate,
    };
  }

  render() {
    return React.Children.only(this.props.children);
  }
}
